<template>
  <div>
    <LmListV2
      ref='LmProcessTypesListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Tipos de Trámites',
      gqlField: 'ProcessTypes',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[ProcessTypesESSortEnum]) {
      ProcessTypes(
          titleList: "Listado de Tipos de Trámites"
          aggs: []
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/tiposdetramites/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/tiposdetramites/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info",buttonColor:"#17a2b8",enableOnSelectedRows:false,type:"redirect",requestEndpoint:"",requestConfirmation:false}]
          ) {
          count
          searcher
          tableItemsTotal
          titleList
          filter {
            aggregatesToSelect
          }
          table {
            items {
              typeName,typeAlias,typePrefix,isEditable,published,deleted,createdBy,updatedBy,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: ['id', 'typeName', 'typeAlias', 'typeDescription', 'typeClasification', 'tadAvailable', 'createdAt', 'updatedAt', 'typePrefix', 'typeWorkflow', 'isEditable', 'published', 'deleted', 'createdBy', 'updatedBy', 'actions'],
      searchOnFieldsToSelected: ['id', 'typeName', 'typeAlias', 'typeDescription', 'typeClasification', 'tadAvailable', 'createdAt', 'updatedAt', 'typePrefix', 'typeWorkflow', 'isEditable', 'published', 'deleted', 'createdBy', 'updatedBy', 'actions'],
      items: [
        {
          name: 'id',
          description: 'id'
        },
        {
          name: 'typeName',
          description: 'Nombre'
        },
        {
          name: 'typeAlias',
          description: 'Alias'
        },
        {
          name: 'typeDescription',
          description: 'Descripción'
        },
        {
          name: 'typeClasification',
          description: 'Clasificación'
        },
        {
          name: 'tadAvailable',
          description: 'Disponible TAD'
        },
        {
          name: 'instanceStarters',
          description: 'Iniciadores del trámite'
        },
        {
          name: 'createdAt',
          description: 'Creado'
        },
        {
          name: 'updatedAt',
          description: 'Actualizado'
        },
        {
          name: 'typePrefix',
          description: 'Prefijo'
        },
        {
          name: 'typeWorkflow',
          description: 'Workflow'
        },
        {
          name: 'isEditable',
          description: 'Es editable'
        },
        {
          name: 'published',
          description: 'Publicado'
        },
        {
          name: 'deleted',
          description: 'En baja lógica'
        },
        {
          name: 'createdBy',
          description: 'Creado por'
        },
        {
          name: 'updatedBy',
          description: 'Actualizado por'
        },
        {
          name: 'actions',
          description: 'Acciones'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [
        {
          key: 'typeName',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'typeAlias',
          label: 'Alias',
          sortable: true
        },
        {
          key: 'typePrefix',
          label: 'Prefijo',
          sortable: false
        },
        {
          key: 'isEditable',
          label: 'Es editable',
          sortable: false
        },
        {
          key: 'published',
          label: 'Publicado',
          sortable: true
        },
        {
          key: 'deleted',
          label: 'En baja lógica',
          sortable: true
        },
        {
          key: 'createdBy',
          label: 'Creado por',
          sortable: false
        },
        {
          key: 'updatedBy',
          label: 'Actualizado por',
          sortable: false
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
